import { Box, Typography } from '@mui/material';
import React from 'react';
import ReactLoading from 'react-loading';
import './style.css';
const EmptyComponent = (props) => {
  const { isLoading } = props;
  return (
    <>
      {isLoading ? (
        <ReactLoading
          type="cylon"
          height="80px"
          width="80px"
          color="#39a2e8"
          className="loading-align"
        />
      ) : (
        <Box className="data-not-found">
          <Typography>Data not found</Typography>
        </Box>
      )}
    </>
  );
};

export default EmptyComponent;
